import axios from 'axios';
import searchSelect from '../select-search';

const JS_PREFIX = 'js-walk-school-picker';
const DEFAULT_MODE = 'default';

const schoolPicker = (() => {
  const self = {
    lang: document.documentElement.lang,
    dom: {
      el: null,
      schoolSelect: null,
      postOfficeSelect: null
    },
    requestExtraParams: {
      school: null,
      schoolList: null
    },
    datePicker: null,
    schoolChoices: null,
    postOfficeChoices: null,
    subscribers: [],
    async loadSchool(schoolId) {
      if(!schoolId) {
        return;
      }
      self.notifySubscribers('loading', schoolId);

      const res = await axios.get('/stage-ajax/unicef-walk/fi/school/' + schoolId + '/', {
        params: {
          'stage-language': self.lang,
          mode: self.mode,
          ...self.requestExtraParams.school
        }
      });
      const data = res && res.data;
      self.notifySubscribers('complete', schoolId, data.result && data.result || null);
    },
    setExtraRequestParams(request, params) {
      if(typeof self.requestExtraParams[request] !== undefined && params && typeof params === 'object') {
        self.requestExtraParams[request] = params
      }
    },
    emptySchoolSelect() {
      self.schoolSelect.clear();
      self.schoolSelect.clearOptions();
    },
    populateSchools(schoolList) {
      // Insert empty school option

      const options = [];
      schoolList.forEach(school => {
        options.push({
          value: school.value,
          text: school.name
        });
      });

      self.schoolSelect.addOptions(options);

    },
    on(event, callback) {
      this.subscribers.push({
        event,
        callback
      });
    },
    notifySubscribers(event, school, data) {
      this.subscribers.forEach(item => {
        if(item.event === event) {
          item.callback(school, data);
        }
      });
    },
    /**
     * Create unique values for post office select values
     *
     * `select-search` (using `tom-select`) does not support duplicate values (yet?) so we have to create unique values
     * https://github.com/orchidjs/tom-select/discussions/210
     */
    createUniquePostOfficeSelectValues() {
      let counter = 0;
      self.dom.postOfficeSelect.querySelectorAll('option').forEach(function (option) {
        const originalValue = option.value;
        if (originalValue) {
          option.value = originalValue + '---' + counter++;
        }
      });
    }
  }
  function init(container) {
    self.dom.el = container;

    // Mode defines if we should fetch registered school data or default data
    self.mode = self.dom.el.dataset.mode || DEFAULT_MODE;

    self.dom.schoolSelect = self.dom.el.querySelector('.' + JS_PREFIX + '__school');
    self.schoolSelect = searchSelect.initSingle(document.querySelector('.' + JS_PREFIX + '__school'));

    self.dom.postOfficeSelect = self.dom.el.querySelector('.' + JS_PREFIX + '__post-office');
    self.createUniquePostOfficeSelectValues();
    self.datePicker = document.querySelector('.js-walk-registration__datepicker');
    self.postOfficeSelect = searchSelect.initSingle(document.querySelector('.' + JS_PREFIX + '__post-office'));
    if (self.datePicker) {
      self.postOfficeSelect.disable();
      self.datePicker.addEventListener('change', (e) => {
        e.target.value && self.postOfficeSelect.enable();
      });
    }

    if (!self.dom.postOfficeSelect.value) {
      self.schoolSelect.disable();
    }


    self.dom.postOfficeSelect.addEventListener('change', function (e) {
      // Handle unique post office select value by only using first part.
      // https://github.com/orchidjs/tom-select/discussions/210

      const value = this.value.split('---')[0];
      const postalCodes = value.split(',');

      self.emptySchoolSelect();

      self.schoolSelect.disable();
      if(!value) {
        return;
      }

      axios.get('/stage-ajax/unicef-walk/fi/school-list/', {
        params: {
          postalCodes: postalCodes,
          'stage-language': self.lang,
          mode: self.mode,
          ...self.requestExtraParams.schoolList
        }
      }).then(res => {
        const data = res && res.data;

        if(data) {
          self.populateSchools(data.result.schoolList);
          self.schoolSelect.enable();
        }
      });
    });

    self.dom.schoolSelect.addEventListener('change', function (e) {
      const school = this.value;
      self.notifySubscribers('change', school);
      return self.loadSchool(school)
    });
  }

  return {
    init,
    on: self.on.bind(self),
    setExtraRequestParams: self.setExtraRequestParams.bind(self),
    loadSchool: self.loadSchool.bind(self)
  };

})();

export default schoolPicker;
export { schoolPicker };
